import { redirect, type RouteObject } from 'react-router';

import { HelpResourcesLayout } from 'src/pages/HelpResources/ui';
import ContactUsPage from 'src/pages/HelpResources/ContactUs';
import InformationLinksPage from 'src/pages/HelpResources/InformationLinks';
import FeedbackPage from 'src/pages/HelpResources/Feedback';
import { HelpResourcesRoutesEnum } from 'src/pages/HelpResources/model';

export const helpResourcesRoutes: RouteObject = {
  element: <HelpResourcesLayout />,
  path: 'help-resources/*',
  loader: async ({ params }) => {
    const { '*': path = '' } = params;
    if (!path) return redirect(`/help-resources/${HelpResourcesRoutesEnum.ContactUs}`);
    if (!Object.values(HelpResourcesRoutesEnum).includes(path as HelpResourcesRoutesEnum)) return redirect('/404');
    return null;
  },
  children: [
    {
      path: HelpResourcesRoutesEnum.ContactUs,
      element: <ContactUsPage />,
    },
    {
      path: HelpResourcesRoutesEnum.InformationLinks,
      element: <InformationLinksPage />,
    },
    {
      path: HelpResourcesRoutesEnum.Feedback,
      element: <FeedbackPage />,
    },
  ],
};
